import * as _4 from 'lodash4';

export class APGradeConfig {
  id: number;
  nk: string;
  min_grade_text: string;
  actual_grade_text: string;
  grade_explanation: string;

  constructor(gradeConfig: APGradeConfig) {
    _4.merge(this, {}, gradeConfig);
  }
  static build(gradeConfig: APGradeConfig): APGradeConfig {
    return new APGradeConfig(gradeConfig);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_gradeconfig_builder.ts